/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

/** Finds a node by `organizationId`, falling back to `groupId`. */
const getOrganizationKeyByOrgId = (
  OrgIdToDelete: string,
  organizationOrigionaldata: any
) => {
  // const organizationOrigionaldata = useSelector(
  //   (state: RootState) => state.organisation.treeTableOrganization
  // );
  let foundValue = false;
  let ValueOfReturnedNode: any = null;
  const dfs = (rootNode: any, targetValue: any) => {
    if (foundValue) {
      return;
    }
    if (rootNode === null || rootNode === undefined) {
      return null;
    }
    if (
      rootNode?.data?.organizationId === targetValue ||
      rootNode?.data?.groupId === targetValue
    ) {
      return rootNode;
    }

    if (rootNode?.children === undefined) {
      return;
    }

    // Loop through all children of the current node
    // istanbul ignore next
    // eslint-disable-next-line array-callback-return
    rootNode?.children?.map((x: any, index: any) => {
      const valueOfNode = dfs(x, targetValue);
      if (valueOfNode) {
        foundValue = true;
        ValueOfReturnedNode = valueOfNode;
        return valueOfNode;
      }
    });
    return ValueOfReturnedNode;
  };

  if (
    organizationOrigionaldata === undefined ||
    organizationOrigionaldata === null ||
    organizationOrigionaldata[0] === undefined ||
    organizationOrigionaldata[0] === null
  ) {
    return null;
  }

  return dfs(
    Object.entries(organizationOrigionaldata)[0][1] ?? [],
    OrgIdToDelete
  );
};
export default getOrganizationKeyByOrgId;
